// extracted by mini-css-extract-plugin
export default {"ModalRequestSent":"ModalRequestSent_ModalRequestSent__8rkIc","ModalRequestSent__footer":"ModalRequestSent_ModalRequestSent__footer__hHDS+"};